export const GoStopAndSaveSearchDialogMessage = {
    modalTitle: 'Save Search',
    modalContent:
        'Save current search technical data without Cevo Go results to your Cevo dashboard, and start a new Cevo Go search?',
    primaryActionTitle: 'Yes',
    successfulAlertMessage:
        'Application information has been successfully saved to your Cevo dashboard.',
} as const;
